module.exports = __webpack_public_path__ + "static/img/ucsc.ce2ca09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ucsc.jpg
// module id = 4hlf
// module chunks = 0